import { render, staticRenderFns } from "./Proofs.vue?vue&type=template&id=9b6eae9a"
import script from "./Proofs.vue?vue&type=script&lang=js"
export * from "./Proofs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports